export default __webpack_public_path__ + "static/media/flag-pin.dcee6e56.png";